import React from 'react';
import { useIconThemed } from '../use-icon-themed';
export default function IconPanelSuccess() {
  var _useIconThemed = useIconThemed(),
    iconThemed = _useIconThemed.iconThemed;
  return /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    "aria-hidden": true,
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: iconThemed({
      light: '#FFF',
      dark: '#161A1D'
    }),
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: iconThemed({
      light: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
      dark: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    }),
    x: 8,
    y: 12,
    width: 32,
    height: 16,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 24a4 4 0 110-8 4 4 0 010 8zm.682-5.482l-1.076 2.055-.772-.695a.5.5 0 00-.668.744l1.25 1.125a.5.5 0 00.777-.14l1.375-2.625a.5.5 0 00-.886-.464z",
    fill: iconThemed({
      light: "var(--ds-icon-success, #22A06B)",
      dark: "var(--ds-icon-success, #22A06B)"
    })
  })));
}